mutation updateIsPhoneOptionalSettings($input: UpdateIsPhoneOptionalSettingsInput!) {
  updateIsPhoneOptionalSettings(input: $input) {
    company {
      isPhoneOptional
    }
  }
}
